import * as types from '../mutation-type'

const state = {
  login_show: false, // 登录显示
  choose_menu: '',
  reg_show: false, // 注册显示
  forget_show: false, // 忘记密码显示
  isVertifySucc: false, // 滑条验证码显示
  bind_menu: true, // 信息绑定显示
  score: 0, // 路径找不到网页显示错误页面
  score_show: 0, // vip积分
  read_num: 0 // 我的消息未读条数
}

const getters = {
  login_show: state => state.login_show,
  choose_menu: state => state.choose_menu,
  reg_show: state => state.reg_show,
  forget_show: state => state.forget_show,
  isVertifySucc: state => state.isVertifySucc,
  bind_menu: state => state.bind_menu,
  score: state => state.score,
  score_show: state => state.score_show,
  read_num: state => state.read_num
}

const mutations = {
  [types.CHANGE_LOGIN_SHOW] (state, data) {
    state.login_show = data
  },
  [types.CHOOSE_MENU] (state, data) {
    state.choose_menu = data
  },
  [types.BIND_MENU] (state, data) {
    state.bind_menu = data
  },
  [types.CHANGE_REG_SHOW] (state, data) {
    state.reg_show = data
  },
  [types.CHANGE_FORGET_SHOW] (state, data) {
    state.forget_show = data
  },
  [types.CHANGE_ISVERTIFYSUCC] (state, data) {
    state.isVertifySucc = data
  },
  [types.SCORE] (state, data) {
    state.score = data
  },
  [types.SCORE_SHOW] (state, data) {
    state.score_show = data
  },
  [types.READ_NUM] (state, data) {
    state.read_num = data
  }
}

const actions = {
  change_login_show ({commit}, param) {
    commit(types.CHANGE_LOGIN_SHOW, param)
  },
  choose_menu ({commit}, param) {
    commit(types.CHOOSE_MENU, param)
  },
  change_reg_show ({commit}, param) {
    commit(types.CHANGE_REG_SHOW, param)
  },
  change_forget_show ({commit}, param) {
    commit(types.CHANGE_FORGET_SHOW, param)
  },
  change_isvertifysucc ({commit}, param) {
    commit(types.CHANGE_ISVERTIFYSUCC, param)
  },
  bind_menu ({commit}, param) {
    commit(types.BIND_MENU, param)
  },
  score ({commit}, param) {
    commit(types.SCORE, param)
  },
  score_show ({commit}, param) {
    commit(types.SCORE_SHOW, param)
  },
  read_num ({commit}, param) {
    commit(types.READ_NUM, param)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/toShow.js